import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider } from './ThemeContext';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Kubernetes from './pages/Kubernetes';
import Openshift from './pages/Openshift';
import Python from './pages/Python';
import AWS from './pages/AWS';
import AI from './pages/AI';
import SystemDesign from './pages/SystemDesign';
import ClusterUpgrade from './pages/ClusterUpgrade';
import KubernetesSecurity from './pages/KubernetesSecurity';
import PythonInheritance from './pages/PythonInheritance';
import LoadBalancer from './pages/LoadBalancer';
import OpenshiftStorage from './pages/OpenshiftStorage';
import OpenshiftWorkloads from './pages/OpenshiftWorkloads';
import KubernetesTLS from './pages/KubernetesTLS';
import AWSNetworking from './pages/AWSNetworking';
import PythonFileHandlingTest from './pages/PythonFileHandlingTest';
import PythonJson from './pages/PythonJson';
import PythonPandas from './pages/PythonPandas';
import PythonThreading from './pages/PythonThreading';
import PythonThreadingVsMultiprocessing from './pages/PythonThreadingVsMultiprocessing';
import PythonThreadingExercises from './pages/PythonThreadingExercises';
import PythonThreadingExercises2 from './pages/PythonThreadingExercises2';
import OpenshiftSCC from './pages/OpenshiftSCC';
import OpenshiftOverview from './pages/OpenshiftOverview';
import Database from './pages/Database';
import DBCommands from './pages/DBCommands';
import DatabaseZeroToHero from './pages/DatabaseZeroToHero';
import './App.css';

function App() {
  return (
    <ThemeProvider>
      <Router>
        <div className="app">
          <Navbar />
          <main className="main-content">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/kubernetes" element={<Kubernetes />} />
              <Route path="/openshift" element={<Openshift />} />
              <Route path="/python" element={<Python />} />
              <Route path="/aws" element={<AWS />} />
              <Route path="/ai" element={<AI />} />
              <Route path="/system-design" element={<SystemDesign />} />
              <Route path="/kubernetes/cluster-upgrade" element={<ClusterUpgrade />} />
              <Route path="/kubernetes/security" element={<KubernetesSecurity />} />
              <Route path="/python/inheritance" element={<PythonInheritance />} />
              <Route path="/system-design/load-balancer" element={<LoadBalancer />} />
              <Route path="/openshift/storage" element={<OpenshiftStorage />} />
              <Route path="/openshift/workloads" element={<OpenshiftWorkloads />} />
              <Route path="/kubernetes/tls" element={<KubernetesTLS />} />
              <Route path="/aws/networking" element={<AWSNetworking />} />
              <Route path="/python/test" element={<PythonFileHandlingTest />} />
              <Route path="/python/json" element={<PythonJson />} />
              <Route path="/python/pandas" element={<PythonPandas />} />
              <Route path="/python/threading" element={<PythonThreading />} />
              <Route path="/python/threading-vs-multiprocessing" element={<PythonThreadingVsMultiprocessing />} />
              <Route path="/python/threading-exercises" element={<PythonThreadingExercises />} />
              <Route path="/python/threading-exercises-2" element={<PythonThreadingExercises2 />} />
              <Route path="/openshift/scc" element={<OpenshiftSCC />} />
              <Route path="/openshift/overview" element={<OpenshiftOverview />} />
              <Route path="/database" element={<Database />} />
              <Route path="/database/db-commands" element={<DBCommands />} />
              <Route path="/database/zero-to-hero" element={<DatabaseZeroToHero />} />
            </Routes>
          </main>
        </div>
      </Router>
    </ThemeProvider>
  );
}

export default App;
